export default {
    ENVIRONMENT_NAME: ENVIRONMENT_NAME,
    GRAPH_QL: GRAPH_QL,
    API_GW: API_GW,
    IS_LOCAL: IS_LOCAL,
    BUNDLE_REF: BUNDLE_REF,
    PUBLIC_URL: PUBLIC_URL
};
